// https://stackoverflow.com/a/56859650
import {
  getDefaultNormalizer,
  type MatcherFunction,
} from '@testing-library/react'

type Query = (f: MatcherFunction) => HTMLElement

const withMarkup =
  (query: Query) =>
  (text: string): HTMLElement => {
    try {
      const normalizer = getDefaultNormalizer({
        trim: true,
        collapseWhitespace: true,
      })

      return query((content: string, node: Element) => {
        const hasText = (textNode: Element) =>
          normalizer(textNode.textContent) === text

        const childrenDontHaveText = Array.from(node.children).every(
          (child) => !hasText(child)
        )
        return hasText(node) && childrenDontHaveText
      })
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(
        `Unable to find an element with the text: ${text}. \n Raw error: ${e}`
      )
    }
  }

export { withMarkup }
